/**
 * Ориентация печати — альбомная и книжная.
 *
 * Своя пара глифов, потому что в Phosphor её нет: там есть один `Rectangle`, и
 * он **квадратный**. Первый заход на #1329 рисовал обе кнопки им, повернув
 * книжную на 90° — на экране получились две одинаковые фигуры, и выбрать
 * ориентацию стало невозможно. Поймано скриншотом sidebar'а печати.
 *
 * Геометрия повторяет манеру Phosphor: скруглённый контур, заливки нет, толщина
 * пропорциональна размеру (у Phosphor `regular` — 16 единиц на 256, здесь то
 * же соотношение), цвет наследуется через `currentColor`.
 *
 * @param {object} props
 * @param {'landscape' | 'portrait'} props.variant — какая ориентация.
 * @param {number} [props.size] — сторона в px, как у иконок Phosphor.
 * @param {string} [props.className]
 * @param {string} [props.ariaLabel] — если задан, иконка становится `role="img"`.
 */
export const OrientationIcon = ({ variant, size = 20, className, ariaLabel }) => {
  const landscape = variant === 'landscape';
  // Прямоугольник вписан в квадратный viewBox 256×256 — так иконка встаёт в
  // одну сетку с остальными глифами Phosphor.
  const w = landscape ? 192 : 136;
  const h = landscape ? 136 : 192;
  const x = (256 - w) / 2;
  const y = (256 - h) / 2;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={ariaLabel ? 'img' : undefined}
      aria-hidden={ariaLabel ? undefined : 'true'}
      aria-label={ariaLabel}
    >
      {ariaLabel ? <title>{ariaLabel}</title> : null}
      <rect
        x={x}
        y={y}
        width={w}
        height={h}
        rx="16"
        stroke="currentColor"
        strokeWidth="16"
      />
    </svg>
  );
};

/** Готовые компоненты под проп `icon` у `IconToggleGroup` / `SegmentedControl`. */
export const OrientationLandscapeIcon = (props) => <OrientationIcon {...props} variant="landscape" />;
export const OrientationPortraitIcon = (props) => <OrientationIcon {...props} variant="portrait" />;
